import React, { useState } from 'react';
import { ITicketProps } from '../../types/Ticket/ITicket';
import { SvgIcon } from '@progress/kendo-react-common';
import { WindowActionsEvent, WindowActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { Window } from '@progress/kendo-react-dialogs';
import { isMobile } from 'react-device-detect';
import { useNavigate, useParams } from 'react-router-dom';
import { TicketApi } from '../../redux/api/TicketApi';
import { UserApi } from '../../redux/api/UserApi';
import { PartialSpinny } from '../Nav/Spinny';
import EditAssignment from '../Ticket/TicketDetails/Sections/Tools/Reassign/EditAssignment';
import * as svg from '@progress/kendo-svg-icons';
import EditAllocation from './EditAllocation';
import { IAllocationData } from '../../types/Gameplan/IAllocation';
import { GameplanApi } from '../../redux/api/GameplanApi';
import { toMinutes } from '../../utils/utils';



const AllocationModal: React.FC = () => {
    const navigate = useNavigate();
    const { ticketId } = useParams();
    const [selectedUser, setSelectedUser] = useState();
    const [stage, setStage] = useState(isMobile ? 'FULLSCREEN' : 'DEFAULT');
    const { data: userProfile } = UserApi.useGetUserProfileQuery();
    const [newAssignees, setNewAssignees] = useState<number[]>([]);
    const { data: ticket } = TicketApi.useGetTicketQuery({ ticketId: parseInt(ticketId) }, { skip: !ticketId });
    const [allocation, setAllocation] = useState<IAllocationData>();
    const [saveAllocation, { isLoading: savingChanges }] = GameplanApi.useUpdateAllocationMutation();

    //navigate back when the winow is closed
    const onStageChange = (e: WindowActionsEvent) => {
        //setVisible(false);
        setStage(e.state)
    }

    const handleSave = (e) => {
        if (allocation) {
            saveAllocation({ ticketId: parseInt(ticketId), data: { Effort_Mins: allocation.Effort_Mins, Allocation: allocation.Allocation.filter(a => a.Checked) } }).unwrap().then(() => {
                //Go back   
                navigate('/ticket/' + ticketId);
            });
        } else {
            goBack();
        }
    };


    const goBack = () => {
        navigate('/ticket/' + ticketId);
    }

    const totalPercent = allocation?.Allocation?.reduce((total, user) => total + (user.Checked ? user.Assigned_Percent : 0), 0);


    if (!ticket) { return null; }

    return (
        <Window modal={true} className='cool-window reassign-window' minimizeButton={() => null} title={<><SvgIcon size='large' icon={svg.userOutlineIcon} className='mr-2' ></SvgIcon>Edit Allocation</>} onClose={() => navigate(-1)}
            initialHeight={720} initialWidth={Math.min(800, window.innerWidth)} stage={stage} onStageChange={onStageChange}>
            {savingChanges && <PartialSpinny />}
            <EditAllocation {...ticket as ITicketProps} onAllocationChange={(e) => setAllocation(e)} allocationData={allocation} />
            <style>
                {`body, html{
                max-height: 100vh;
                overflow: hidden;
            }`}
            </style>
            <WindowActionsBar>
                <Button disabled={totalPercent !== 100} onClick={handleSave} svgIcon={svg.saveIcon} type='submit' className='justify-content-end p-2' style={{ marginTop: '20px', color: '#fff', backgroundColor: userProfile?.Nav_Hex_Color }}>
                    Save Allocation
                </Button>
                <Button fillMode='outline' svgIcon={svg.cancelIcon} className='justify-content-end p-2' style={{ marginTop: '20px' }} onClick={goBack}>
                    Cancel
                </Button>
            </WindowActionsBar>
        </Window>
    );
};

export default AllocationModal;